import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseHttpService } from "./base.http.service";
import {
  CheckCompanyRegistrationResponse,
  CompanyDto,
  EInvoiceResponse,
  PdfData,
  ReverseChargeReason,
  SalesInvoiceRequest,
  SalesInvoiceResponse,
  StornoRequestDto,
  UBLInvoiceToAddRequestDto,
} from "../types/e-invoice";

@Injectable({
  providedIn: "root",
})
export class EInvoiceService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  createUBLInvoice(request: UBLInvoiceToAddRequestDto): Observable<EInvoiceResponse> {
    const params = new HttpParams()
      .set("requestId", request.requestId)
      .set("sendToCir", request.sendToCir.toString())
      .set("executeValidation", request.executeValidation.toString())
      .set("invoiceId", request.invoiceId.toString())
      .set("contractNumber", request.contractNumber ?? "")
      .set("type", request.type?.toString() ?? "");

    const body = {
      taxCategory: request.taxCategory,
      amount: request.amount,
      initialAmount: request.initialAmount,
      taxExemptionReasonCode: request.taxExemptionReasonCode,
      taxExemptionReason: request.taxExemptionReason,
      descriptionCode: request.descriptionCode,
      dueDate: request.dueDate,
      actualDeliveryDate: request.actualDeliveryDate ?? null,
    };

    return this.http.post<EInvoiceResponse>(`${this.apiUrl}/api/EInvoice/ubl`, body, { params });
  }

  getSalesInvoiceIds(request: SalesInvoiceRequest): Observable<SalesInvoiceResponse> {
    return this.http.post<SalesInvoiceResponse>(`${this.apiUrl}/api/EInvoice/sales/ids`, request);
  }

  getSalesInvoicePdf(invoiceId: number): Observable<PdfData> {
    const url = `${this.apiUrl}/api/EInvoice/sales/pdf/${invoiceId}`;
    return this.http.get<PdfData>(url);
  }

  stornoSalesInvoice(requestDto: StornoRequestDto): Observable<void> {
    const url = `${this.apiUrl}/api/EInvoice/sales/storno`;
    return this.http.post<void>(url, requestDto);
  }

  getAllCompanies(includeAllStatuses = false): Observable<CompanyDto[]> {
    const params = new HttpParams().set("includeAllStatuses", includeAllStatuses.toString());
    return this.http.get<CompanyDto[]>(`${this.apiUrl}/api/EInvoice/allCompanies`, { params });
  }

  checkIfCompanyRegistered(planId: number): Observable<CheckCompanyRegistrationResponse> {
    const url = `${this.apiUrl}/api/EInvoice/check-company-registration/${planId}`;
    return this.http.post<CheckCompanyRegistrationResponse>(url, {});
  }

  getReverseChargeReasons(): Observable<ReverseChargeReason[]> {
    const url = `${this.apiUrl}/api/EInvoice/reverse-charge-reasons`;
    return this.http.get<ReverseChargeReason[]>(url);
  }
}
